<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    this.iniUrl();
  },
  methods: {
    iniUrl: async function() {
      const currentUrl = window.location.href;
      const url = new URL(currentUrl);
      const params = new URLSearchParams(url.search);

      if (params.size > 0) {
        const code = params.get("code");
        console.log('code',code)
        if (code) {

          localStorage.setItem("code", code);
          // request({
          //   url: "/api/associate/login",
          //   method: "post",
          //   data: {
          //     code,
          //   }
          // })
          
          
          this.$store.dispatch("Login", {code}).then(res => {
            console.log(res,'res')
            params.delete("code");
            params.delete("state");
            const newUrl = `${url.origin}${url.pathname}?${params.toString()}`;
            console.log('newUrl',newUrl)
            window.location.replace(newUrl);
          }).catch(error => {
            reject(error);
          });


        }
      }
    }

  }
}
</script>
